export function zaehlernummer(value) {
  return {
    valid: !value || /^(1200[a-zA-Z0-9]{6}|[a-zA-Z0-9]{10}|[a-zA-Z0-9]{14}|[a-zA-Z0-9]{6})$/.test(value),
    errorMessage: 'Ihre Zählernummer darf nur 6, 10 oder 14 Zeichen und keine Sonderzeichen enthalten.',
  }
}
